import { Box } from '@shopify/polaris';

export function FauxCard({ children, padding = '400', shadow = 'sm', ...rest }) {
    return (
        <Box background="surface" border="base" borderRadius="200" shadow={shadow} padding={padding} borderWidth="025" borderColor="border" {...rest}>
            {children}
        </Box>
    );
}
